/* eslint-disable jira/filename-case */
/**
 * @fileOverview this is a temporal file to support hydration rollout in Jira
 * It will be removed once the rollout is complete
 */
import React, { memo, Component } from 'react';

if (typeof window !== 'undefined') {
	const altFlags = new URLSearchParams(window.location.search).get('alt-flags');

	// `no-effects` flag disables all useEffect and useLayoutEffect calls
	// making Jira "static"
	if (altFlags?.includes('no-effects')) {
		// Disable useEffect calls to allow hydration to focus on Structure only
		// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
		React.useEffect = () => {}; // oxlint-disable-line no-empty-function
		// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
		React.useLayoutEffect = () => {}; // oxlint-disable-line no-empty-function

		// oxlint-disable-next-line no-console
		console.warn('⛔️ React.useEffect is disabled ⛔️');
	}

	// `memo-all` flags causes all components to be wrapped in React.memo
	// React compiler without using compiler
	if (altFlags?.includes('memo-all')) {
		// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
		const originalCreateElement = React.createElement;

		const componentMapping = new Map();

		/* oxlint-disable @typescript-eslint/no-explicit-any */
		// eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
		React.createElement = (type: any, ...args: any[]): any => {
			// delegate incorrect or plain components
			if (!type || typeof type === 'string') {
				return originalCreateElement(type, ...args);
			}

			// do not handle Class components
			if (
				type.prototype &&
				(Object.prototype.isPrototypeOf.call(Component.prototype, type.prototype) ||
					type.prototype.isReactComponent || // with support for React 14(!) components still being in use
					type.prototype.render)
			) {
				return originalCreateElement(type, ...args);
			}

			if (typeof type === 'function' || typeof type === 'object') {
				let standin = componentMapping.get(type);
				// for every function generate a standin to preserve req equality
				// this is not required for "single pass" render to string, but is a must-have to renderToStream
				if (!standin) {
					standin = memo(type);
					componentMapping.set(type, standin);
				}

				return originalCreateElement(standin, ...args);
			}
			return originalCreateElement(type, ...args);
		};
		/* oxlint-enable @typescript-eslint/no-explicit-any */
	}
}
